import axios from "axios";
import axiosInstance from "./axiosInstance";

const API_URL =
  process.env.REACT_APP_SPL_API_URL || "https://new.aquastrong-select.ru";

const dev = () => (window.__devMode ? "/dev" : "");

export const setDevMode = (v) => { window.__devMode = v; };

export const requestSeries = (prefix = "series", seriesNumber = "") => {
  let url = `${API_URL}${dev()}/api/v1/search/pump/${prefix}`;
  if (seriesNumber) {
    url += `/${seriesNumber}`;
  }
  return axiosInstance.get(url);
};

export const filterSeries = (seriesNumber, data) =>
  axiosInstance.post(
    `${API_URL}${dev()}/api/v1/search/pump/filter/${seriesNumber}`,
    data
  );

export const getPumpData = (id, data) => {
  const method = data ? "post" : "get";
  return axiosInstance({
    method,
    url: `${API_URL}${dev()}/api/v1/search/pump/${id}`,
    data,
  });
};

export const getPumpHash = (id, data = null, units = null) => {
  if (data !== null) {
    return axiosInstance({
      method: "post",
      url: `${API_URL}${dev()}/api/v1/search/pump/files/${id}`,
      data,
    });
  }

  const url = units
    ? `${API_URL}${dev()}/api/v1/search/pump/files/${id}/${units}`
    : `${API_URL}${dev()}/api/v1/search/pump/files/${id}`;

  return axiosInstance({
    method: "get",
    url,
  });
};

export const findOptionsByHash = async (
  hash,
  signal,
  timeout = 15000,
  pollInterval = 1500
) => {
  let lastData = {
    error: null,
    files: null,
    response: null,
  };

  const defaultErrorMessage = "Ошибка во время выполнения запроса. ";
  const networkErrorMessage = "Не удалось подключиться к серверу.";

  const startTime = Date.now();

  while (true) {
    if (signal?.aborted) {
      break;
    }

    if (Date.now() - startTime >= timeout) {
      lastData = {
        ...lastData,
        error: "Время ожидания истекло",
      };
      break;
    }

    try {
      const url = `${API_URL}/api/v1/request/${hash}`;

      const response = await axios.get(url, { signal });

      lastData = response.data;

      if (response.data.files !== null) {
        return response.data;
      }

      if (response.data.error) {
        return {
          ...response.data,
          error: response.data.error,
        };
      }

      if (response.data.response?.error) {
        return {
          ...response.data,
          error: JSON.stringify([{ message: response.data.response.error }]),
        };
      }
    } catch (error) {
      lastData = {
        ...lastData,
        error: defaultErrorMessage + networkErrorMessage,
      };
      break;
    }

    await new Promise((resolve) => {
      const timer = setTimeout(resolve, pollInterval);
      if (signal) {
        signal.addEventListener(
          "abort",
          () => {
            clearTimeout(timer);
            resolve();
          },
          { once: true }
        );
      }
    });
  }

  return lastData;
};

export const getDevMode = () => window.__devMode;